import React, { FC } from "react";
import colors from "constants/colors";

interface IProps {
  id?: string;
  header: string;
  progress: number;
  additional?: string;
  description: string;
  className?: string;
  style?: React.CSSProperties;
  fillColor?: string;
}

const ProgressBar: FC<IProps> = ({
  header,
  progress,
  additional,
  description,
  className,
  style,
  fillColor,
  id
}) => {
  return (
    <div className={`progress-bar-container ${className || ""}`} id={id} data-tid={id}>
      <div className="progress-bar-header">{header}</div>
      <div className="status-bar-line-container">
        <div
          className="status-bar-line-progress"
          style={{
            width: `${progress.toFixed(0)}%`,
            background: fillColor || colors.instructorGreen,
            ...style
          }}
        />
      </div>
      <div className="progress-bar-content">
        <div className="additional-data">{additional && `${additional}`}</div>
        <div>{description}</div>
      </div>
    </div>
  );
};

export default ProgressBar;
